"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const matchStatus = (actual, expected) => {
    if (!actual) {
        return false;
    }
    return actual.toLowerCase() === expected.toLowerCase();
};
exports.default = matchStatus;
//# sourceMappingURL=match-status.js.map